//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import slider from '../global/slider.vue'
export default {
  components: { slider },
  props: {
    baseSku: { type: String, required: true },
    productDetails: { type: Object, required: true },
    productName: { type: String, required: true }
  }
}
